<template lang="pug">
  #super-admin-reports.box
    WtTile(ancestor :col="12")

    .card.mb-4
      .card-content.no-padding
        WtTile(parent :col="12").no-padding.reportTile
          WtTile(child :col="4").no-padding
            WtTitle(h5) Every Step Report
            WtTitle(h6) Warning: File will be large!
            | This downloads every step entry by date, including any converted steps from activities.
          WtTile(child :col="6").no-padding
            WtTile(parent :col="12").no-padding

              WtTile(child :col="6").no-padding.pr-2
                BField(label="Start Date")
                  BDatepicker(
                    :min-date="programStartDate"
                    :max-date="new Date()"
                    icon="calendar-today"
                    editable
                    v-model="everyStepReportStartDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :events="startDatePickerEvents"
                    position="is-top-right"
                    append-to-body=true
                  )

              WtTile(child :col="6").no-padding.pr-2
                BField(label="End Date").no-padding
                  BDatepicker(
                    icon="calendar-today"
                    editable
                    v-model="everyStepReportEndDate"
                    :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
                    :min-date="everyStepReportStartDate ? everyStepReportStartDate : programStartDate"
                    :max-date="new Date()"
                    :events="endDatePickerEvents"
                    position="is-top-right"
                    append-to-body=true
                  )

              WtTile(child :col="3").no-padding
                BField(:message="processingDownload ? 'Processing' : ''")
                  WtButton(
                    color="primary"
                    class="download-btn"
                    :loading="processingDownload"
                    @click.native="downloadStepReport"
                  ).mt-5 DOWNLOAD
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile.vue";
import MemberStatsTable from "@@/Program/MemberStatsTable.vue";
import WtButton from "@@/WtButton/WtButton.vue";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "EveryStepReport",
  components: { WtTitle, WtTile, MemberStatsTable, WtButton },
  mixins: [dateUtilityMixin],
  data() {
    return {
      everyStepReportStartDate: null,
      everyStepReportEndDate: null,
      processingDownload: false
    };
  },
  computed: {
    ...mapGetters("program", ["coreProgramMeta", "isCoreTier"]),

    endDatePickerEvents() {
      return this.startDate ? [this.startDate] : null;
    },

    startDatePickerEvents() {
      return this.endDate ? [this.endDate] : null;
    },

    programStartDate() {
      return new Date(
        new Date(this.coreProgramMeta.startDate).setHours(0, 0, 0, 0)
      );
    }
  },
  methods: {
    ...mapActions(["snackBar"]),
    ...mapActions("program", ["everyStepReportDownload"]),

    async downloadStepReport() {
      this.processingDownload = true;

      const payload = {
        programId: this.$auth.user().programId,
        startDate: this.everyStepReportStartDate
          ? this.formatDateForRequest(this.everyStepReportStartDate)
          : this.formatDateForRequest(this.programStartDate),
        endDate: this.everyStepReportEndDate
          ? this.formatDateForRequest(this.everyStepReportEndDate)
          : this.today().formatted
      };
      try {
        let response = await this.everyStepReportDownload(payload);

        var jsonResponse = false;
        try {
          // This errors when the arraybuffer is a csv...
          jsonResponse = JSON.parse(
            new TextDecoder().decode(new Uint8Array(response.data))
          );
        } catch (e) {
          jsonResponse = false;
        }
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
        }
      } catch (error) {
        this.snackBar({
          duration: 10000,
          type: "is-danger",
          message:
            "An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co."
        });
      }
      this.processingDownload = false;
    }
  }
};
</script>
